// -- React Libraries
import React from 'react';
import {Radar, RadarChart, PolarGrid, PolarAngleAxis} from 'recharts';

// -- Components
import MediaQuery from 'react-responsive';
import GridHeader from "../GridHeader/index";
import GridContent from "../GridContent/index";

import ReviewBlock from "../ReviewBlock/index";

// -- Styles
import StyleWrapper from "./Wrapper";

// -- Resources
import Trophy from "../../../../image/trophy.png";
import Warning from "../../../../image/warning.png";

export default class GridRating extends React.Component {
    constructor (props) {
        super(props);

        this.state = { reviewsExpanded: false };
        
        this.isRatingsOk = props.data.isRatingsOk;
        this.isReviewsOk = props.data.isReviewsOk;

        this.averageRating = props.data.averageRating;
        this.appRatingCount = props.data.appUserRatingCount < 1000 ?
            props.data.appUserRatingCount :
            ((props.data.appUserRatingCount / 1000).toFixed(1) + "千");

        this.sentimentAnalyze = [
            { subject: "正评", score: props.data.sentimentAnalyze.positive || 0 },
            { subject: "负评", score: props.data.sentimentAnalyze.negative || 0 },
            { subject: "中性", score: props.data.sentimentAnalyze.neutral || 0 }
        ];

        this.review1 = null;
        this.review2 = null;
        this.review3 = null;

        this.filterReviews(props.data.reviews);
    }

    filterReviews = function (reviews) {
        let sortedReviews = (reviews || []);
        let latestBest = null;
        let latestWorst = null;
        let secondLatestWorst = null;
        
        sortedReviews = sortedReviews.sort( (review1, review2) =>
            parseInt(review1["id"].label) - parseInt(review2["id"].label)
        ).reverse();
        sortedReviews.map( function (review) {
            var rating = parseInt(review["im:rating"].label);
            if (!latestBest || rating > parseInt(latestBest["im:rating"].label)) latestBest = review;
            if (!latestWorst || rating < parseInt(latestWorst["im:rating"].label)) latestWorst = review;
        });

        if (latestWorst)
            sortedReviews.map( function (review) {
                var rating = parseInt(review["im:rating"].label);
                
                if (review["id"].label != latestWorst["id"].label)
                    if (!secondLatestWorst || rating < parseInt(secondLatestWorst["im:rating"].label))
                            secondLatestWorst = review;
            });

        if (sortedReviews) {
            this.review1 = latestBest;
            this.review2 = latestWorst;
            this.review3 = secondLatestWorst;
        }
  
        return reviews;
    }.bind(this);

    render() {
        return (
            <StyleWrapper className="grid-score-summaries">
                <div className="summary-title">
                    评分及评论

                    <div className="ratings">
                        <img className="rating-icon" src={this.isRatingsOk ? Trophy : Warning}/>

                        <div>
                            <span>{(this.averageRating || 0).toFixed(1)}</span>
                            &nbsp;/&nbsp;5
                        </div>
                        
                        <div>共{this.appRatingCount}个评分</div>
                    </div>
                </div>

                {
                    this.review1 && (
                        <div className="reviews">
                            {
                                this.review1 && (
                                    <ReviewBlock className="review" review={this.review1} isExpanded={this.state.reviewsExpanded} />
                                )
                            }
                            {
                                this.review2 && (
                                        <ReviewBlock className="review" review={this.review2} isExpanded={this.state.reviewsExpanded} />
                                )
                            }
                            {
                                this.review3 && (
                                    <ReviewBlock className="review" review={this.review3} isExpanded={this.state.reviewsExpanded} />
                                )
                            }

                            <button className="reviews-toggle" onClick={ () => { this.setState({reviewsExpanded: !this.state.reviewsExpanded}); } }>
                                <i className={`fa fa-caret-${this.state.reviewsExpanded && "up" || "down"}`}></i>
                            </button>
                        </div>
                    )
                }
            
                <div className="grid-container">
                    {/* First Row */}
                    <GridHeader ok={this.isRatingsOk} title="平均评分"></GridHeader>
                    <GridHeader ok={this.isReviewsOk} title="情感分析"></GridHeader>

                    {/* Second Row */}
                    <GridContent title={this.isRatingsOk && "很好！"}>
                        {
                            this.isRatingsOk && (
                                <div>
                                    你的平均评分在四分以上，<span>多于90％的用户</span>愿意下载评分高于四分的应用。                                    
                                </div>
                            ) || (
                                <div>
                                    你的评分需要优化。<span>只有少于50％的用户</span>会下载评分低于四分的应用。
                                </div>
                            )
                        }
                    </GridContent>

                    <GridContent title={this.isReviewsOk && "很好！"}>
                        {
                            this.sentimentAnalyze && (
                                <div>
                                    <MediaQuery maxWidth={480}>
                                        <RadarChart cx={160} cy={95} width={320} height={190} data={this.sentimentAnalyze}>
                                            <PolarGrid />
                                            <PolarAngleAxis dataKey="subject" />
                                            <Radar dataKey="score" stroke="#8884d8" fill="#8884d8" fillOpacity={0.6}/>
                                        </RadarChart>
                                    </MediaQuery>

                                    <MediaQuery minWidth={481} maxWidth={767}>
                                        <RadarChart cx={210} cy={125} width={420} height={250} data={this.sentimentAnalyze}>
                                            <PolarGrid />
                                            <PolarAngleAxis dataKey="subject" />
                                            <Radar dataKey="score" stroke="#8884d8" fill="#8884d8" fillOpacity={0.6}/>
                                        </RadarChart>
                                    </MediaQuery>

                                    <MediaQuery minWidth={768} maxWidth={991}>
                                        <RadarChart cx={140} cy={83} width={280} height={166} data={this.sentimentAnalyze}>
                                            <PolarGrid />
                                            <PolarAngleAxis dataKey="subject" />
                                            <Radar dataKey="score" stroke="#8884d8" fill="#8884d8" fillOpacity={0.6}/>
                                        </RadarChart>
                                    </MediaQuery>

                                    <MediaQuery minWidth={992}>
                                        <RadarChart cx={210} cy={125} width={420} height={250} data={this.sentimentAnalyze}>
                                            <PolarGrid />
                                            <PolarAngleAxis dataKey="subject" />
                                            <Radar dataKey="score" stroke="#8884d8" fill="#8884d8" fillOpacity={0.6}/>
                                        </RadarChart>
                                    </MediaQuery>
                                </div>
                            )
                        }
                    </GridContent>
                    
                    {/* Third Row */}
                    <GridContent title={"小窍门:"}>
                        - <span>59%的用户</span>会于下载新的应用前检视它的评分
                        <br /><br />

                        - 对应用感到满意的用户会比较愿意留下正评，可以在应用中<span>请求用户评分</span>
                        <br /><br />

                        - 定期检视负评，<span>回应用户的需求和解决应用的问题。</span>
                    </GridContent>
                </div>
            </StyleWrapper>
        );
    }
};


// WEBPACK FOOTER //
// ./src/containers/AsoAnalytic/ScoreSummary/GridRating/index.js